//@ts-nocheck потому что это всё копипастой попало сюда, подлежит постепенной утилизации

import { DEFAULT_ODDS_TYPE, ECurrencyCode } from '../constants';
import type { OddsType } from '../types';

export interface ILocalization {
    getString(resourceKey: string, defaultValue?: string): string;
}

type IsMobile = boolean;
type IsResponsive = boolean;
type BonusExchangeRate = number;

export interface GlobalConfig {
    $api: {
        authToken: string;
        appSource: string;
        baltStatServiceUrl: string;
        uniBetServiceUrl: string;
        uniSearchServiceUrl: string;
        uniPersonalInfoCenterUrl: string;
        uniBaltsystemServiceUrl: string;
        uniBonusServiceUrl: string;
        uniCoinGameServiceUrl: string;
        prematchServiceUrl: string;
        uniBaltjetServiceUrl: string;
    };
    $additionalSum: boolean;
    $additionalSumValues: number[];
    $betDeletionMode: string;
    $bettingCartSubMode: string;
    $minBetAmount: number;
    $defaultBet: boolean;
    $defaultBetSum: number;
    $maxWinSumOrdinary: number;
    $maxWinSumExpress: number;
    $CurrencySymbol: string;
    $CurrencyCode: string;
    $countryCode: string;
    $showBalance: boolean;
    $site: string;
    $siteName: string;
    $siteShortName: string;
    $Localization: ILocalization;
    $isAuthorized: boolean;
    $isExclusiveBroadcast: boolean;
    $isIdent: boolean;
    $isLearningEnabled: boolean;
    $isVisibleOldBonusSystem: boolean;
    $isLocalizationEnabled: boolean;
    $isMobile: IsMobile;
    $isResponsive: IsResponsive;
    $culture: string;
    $lang: string;
    $theme: string;
    $timeOffset: number;
    $balance: number;
    $bonuses: number;
    $deposit: number;
    $bonusExchangeRate: BonusExchangeRate;
    $currentUser: {
        isAnonymous: boolean;
        isIdent: boolean;
    };
    $addSums: [number, number, number];
    $isNewCartEnabled: boolean;
    $predskazariumUrl: string;
    $defaultSprite: string;
    $defaultSpriteSports: string;
    $isCartOnboardingEnabled: boolean;
    $isStatisticCardEnabled: boolean;
    $oddsType: OddsType;
    $isPopupMessagesBlocked: boolean;
    $hideCurrency: boolean;
    $isBonusDisabled: boolean;
    $isPreferredLeaguesCheckEnabled: boolean;
    $isDefaultBetMultiplierEnabled: boolean;
}

export function useGlobalConfig(): GlobalConfig {
    const $api = window.globalAppSettings?.api;
    const $betDeletionMode = window.globalAppSettings?.betDeletionMode || '0';
    const $bettingCartSubMode = window.globalAppSettings?.bettingCartSubMode || 'Undefined';
    const $CurrencyCode: string =
        window?.globalAppSettings?.currentUser?.defaultBalance?.currencyCode || ECurrencyCode.RUB;
    const $countryCode = window?.globalAppSettings?.countryCode || 'RU';
    const $currentUser = window?.globalAppSettings?.currentUser;
    const $CurrencySymbol: string = window?.globalAppSettings?.currentUser?.defaultBalance?.currencySymbol || '';
    const $Localization: ILocalization = window.Localization || {
        getString: (_, fallback) => fallback,
    };
    const $balance: number = Number(window?.globalAppSettings?.currentUser?.balance) ?? 0;
    const $bonusExchangeRate: BonusExchangeRate = Number(window?.globalAppSettings?.bonusExchangeRate) ?? 1000;
    const $bonuses: number = window?.globalAppSettings?.currentUser?.bonuses ?? 0;
    const $deposit: number = Number(window?.globalAppSettings?.currentUser?.deposit) ?? 0;
    const $defaultBet: boolean = window?.globalAppSettings?.defaultBet ?? false;
    const $defaultBetSum: number = window?.globalAppSettings?.defaultBetSum ?? 0;
    const $isAuthorized: boolean = !window?.globalAppSettings?.currentUser?.isAnonymous ?? false;
    const $isExclusiveBroadcast: boolean = window?.globalAppSettings?.currentUser?.isExclusiveBroadcast ?? false;
    const $isIdent: boolean = window?.globalAppSettings?.currentUser?.isIdent ?? false;
    const $isLearningEnabled: boolean = window?.globalAppSettings?.currentUser?.isLearningEnabled ?? false;
    const $isVisibleOldBonusSystem = window.globalAppSettings?.currentUser?.isVisibleOldBonusSystem ?? false;
    const $isLocalizationEnabled: boolean = window?.globalAppSettings?.isLocalizationEnabled ?? false;
    const $isMobile: IsMobile = window?.globalAppSettings?.isMobileDevice ?? false;
    const $isResponsive: IsResponsive = !window?.globalAppSettings?.isMobileDeviceInDesktopMode || false;
    const $culture: string = window?.globalAppSettings?.culture || 'ru-RU';
    const $lang: string = window?.globalAppSettings?.lang || 'ru';
    const $theme: string = window?.globalAppSettings?.theme ?? 'dark';
    const $timeOffset: number = Number(window?.globalAppSettings?.timeOffset) ?? 0;
    const $additionalSumValues: [number, number, number] = window?.globalAppSettings?.additionalSumValues ?? [0, 0, 0];
    const $minBetAmount = window.globalAppSettings?.minBetAmount ?? 20;
    const $maxWinSumOrdinary = window.globalAppSettings?.maxWinSumOrdinary;
    const $maxWinSumExpress = window.globalAppSettings?.maxWinSumExpress;
    const $isNewCartEnabled = window.globalAppSettings?.isClientCartEnabled ?? false;
    const $predskazariumUrl = window.globalAppSettings?.predskazariumUrl ?? '';
    const $defaultSprite = window.globalAppSettings?.svg?.defaultSprite ?? '';
    const $defaultSpriteSports = window.globalAppSettings?.svg?.defaultSpriteSports ?? '';
    const $isCartOnboardingEnabled = window.globalAppSettings?.isCartOnboardingEnabled ?? false;
    const $isStatisticCardEnabled = window.globalAppSettings?.isStatisticCardEnabled ?? false;
    const $site = window.globalAppSettings?.site ?? '';
    const $siteName = window.globalAppSettings?.siteName ?? '';
    const $siteShortName = window.globalAppSettings?.siteShortName ?? '';
    const $showBalance = window.globalAppSettings?.showBalance ?? false;
    const $oddsType = window.globalAppSettings?.oddsType ?? DEFAULT_ODDS_TYPE;
    const $isPopupMessagesBlocked = window.globalAppSettings?.isPopupMessagesBlocked ?? false;
    const $hideCurrency = window.globalAppSettings?.hideCurrency ?? false;
    const $isBonusDisabled = window.globalAppSettings?.isBonusDisabled ?? false;
    const $isPreferredLeaguesCheckEnabled = window.globalAppSettings?.isPreferredLeaguesCheckEnabled ?? false;
    const $isDefaultBetMultiplierEnabled = window.globalAppSettings?.isDefaultBetMultiplierEnabled ?? false;

    return {
        $api,
        $betDeletionMode,
        $bettingCartSubMode,
        $defaultBet,
        $maxWinSumOrdinary,
        $maxWinSumExpress,
        $countryCode,
        $CurrencyCode,
        $CurrencySymbol,
        $Localization,
        $balance,
        $bonusExchangeRate,
        $bonuses,
        $deposit,
        $currentUser,
        $defaultBetSum,
        $isAuthorized,
        $isExclusiveBroadcast,
        $isIdent,
        $isLearningEnabled,
        $isVisibleOldBonusSystem,
        $isLocalizationEnabled,
        $isMobile,
        $isResponsive,
        $culture,
        $lang,
        $theme,
        $timeOffset,
        $additionalSumValues,
        $minBetAmount,
        $isNewCartEnabled,
        $predskazariumUrl,
        $defaultSprite,
        $defaultSpriteSports,
        $isCartOnboardingEnabled,
        $isStatisticCardEnabled,
        $site,
        $siteName,
        $siteShortName,
        $showBalance,
        $oddsType,
        $isPopupMessagesBlocked,
        $hideCurrency,
        $isBonusDisabled,
        $isPreferredLeaguesCheckEnabled,
        $isDefaultBetMultiplierEnabled,
    };
}
